import css1 from "../img/portImages/cv_css.png";
import p1 from "../img/portImages/1.png";
import p2 from "../img/portImages/2.png";
import p3 from "../img/portImages/3.png";
import p4 from "../img/portImages/4.png";
import p5 from "../img/portImages/5.png";
import p6 from "../img/portImages/6.png";
import p7 from "../img/portImages/7.png";
import p8 from "../img/portImages/8.png";
import p9 from "../img/portImages/9.png";
import p10 from "../img/portImages/10.png";
import p11 from "../img/portImages/11.png";
import p12 from "../img/portImages/12.png";

const portfolios = [
  {
    id: 1,
    category: "Web Application",
    image: p7,
    link2: "http://matrixinnovation.com/",
    title: "Matrix Innovation Web App",
  },
  {
    id: 2,
    category: "Web Application",
    image: p6,
    link2: "https://internapp.tgnesolutions.com/home/",
    title: "Intern Africa Web App",
  },
  {
    id: 3,
    category: "SME Portals",
    image: css1,
    link2: "https://www.escatech.org/",
    title: "Esca Electricals Ltd Web App",
  },
  {
    id: 4,
    category: "Web Application",
    image: p1,
    link2: "https://mncenergygh.com/",
    title: "MnC Energy Ltd Web App",
  },
  {
    id: 5,
    category: "Ecommerce",
    image: p2,
    link2: "https://tgnesolutions.com/",
    title: "TGNE Solutions Web App",
  },

  {
    id: 6,
    category: "Ecommerce",
    image: p3,
    link2: "https://myautopartsgh.com/",
    title: "My Auto Parts Ghana Web App",
  },
  {
    id: 7,
    category: "SME Portals",
    image: p4,
    link2: "http://www.umcghana.org/",
    title: "UMC Ghana Web App",
  },
  {
    id: 8,
    category: "Business Softwares",
    image: p5,
    link2: "https://parcel.wixiz.com/",
    title: "Logistics Managment Software",
  },

  {
    id: 9,
    category: "Business Softwares",
    image: p9,
    link2: "https://demo.smart-hospital.in/site/login",
    title: "Hospital Managment System",
  },

  {
    id: 10,
    category: "Business Softwares",
    image: p10,
    link2: "https://pos.ultimatefosters.com/login",
    title: "Point of Sale Software",
  },

  {
    id: 11,
    category: "Web Application",
    image: p11,
    link2: "https://softwares.tgnesolutions.com/",
    title: "TGNE Softwares Division",
  },

  {
    id: 12,
    category: "Business Softwares",
    image: p12,
    link2: "https://mis.tgnesolutions.com/authentication/login",
    title: "Management Information System ",
  },
];

export default portfolios;
